export function PlayIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="1" y="1" width="62" height="62" rx="31" fill="green" />
      <rect
        x="1"
        y="1"
        width="62"
        height="62"
        rx="31"
        stroke="#1200FF"
        strokeWidth="2"
      />
      <path
        d="M24.125 42.125L39.875 32.5L24.125 22.875V42.125ZM22.8125 20.6328C23.6328 20.1406 24.6719 20.1406 25.4922 20.6328L41.2422 30.2578C42.0078 30.75 42.5 31.625 42.5 32.5C42.5 33.4297 42.0078 34.3047 41.2422 34.7422L25.4922 44.3672C24.6719 44.9141 23.6328 44.9141 22.8125 44.4219C21.9922 43.9844 21.5 43.1094 21.5 42.125V22.875C21.5 21.9453 21.9922 21.0703 22.8125 20.6328Z"
        fill="#1200FF"
      />
    </svg>
  )
}
